<template>
<div>
  <div class="vx-row">

   

    <!-- MULTIPLE COLUMNS-->
    <div class="vx-col w-full mb-base">
      
      <vx-card title="">
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
           <!--  <customer-component></customer-component>-->
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <product-component @data="stokListeEkle($event)"></product-component>
          </div>

          
        </div>
       

      </vx-card>
    </div>
</div>
    <div class="vx-row">
      
<div class="vx-col lg:w-3/4 w-full relative">

  <vs-table :data="list">

    <template slot="thead">
      <vs-th  sort-key="stokkodu">Kodu</vs-th>
      <vs-th>Adı</vs-th>
      <vs-th>Fiyat</vs-th>
      <vs-th>Adet</vs-th>
      <vs-th>Stok Adet</vs-th>
      <vs-th>Son Alış</vs-th>
      <vs-th>Sil</vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">

        <vs-td :data="data[indextr].stokkodu">
          {{ data[indextr].stokkodu }} {{indextr}}
        </vs-td>
        <vs-td :data="data[indextr].stokadi">
          {{ data[indextr].stokadi }}
        </vs-td>

        <vs-td :data="data[indextr].fiyat">
          <vs-input class="satirinput" size="small"  v-model="data[indextr].fiyat"></vs-input>
          
        </vs-td>

        <vs-td :data="data[indextr].adet">
          <vs-input class="satirinput" type="number" size="small" :ref="'adetinput'" autofocus= "true" ></vs-input>
        </vs-td>

        <vs-td :data="data[indextr].stokadet">
          {{ data[indextr].stokadet }}
        </vs-td>
        <vs-td :data="data[indextr].sonalis">
          {{ data[indextr].sonalis }}
        </vs-td>
        <vs-td :data="data[indextr].sil">
          <vs-button color="danger" size="small" type="gradient" icon-pack="feather" icon="icon-delete" @click="listesil(data[indextr].stokkodu)"></vs-button>
        </vs-td>
      </vs-tr>
    </template>

  </vs-table>



</div>
      <div class="vx-col lg:w-1/4 w-full">
                        <vx-card>
                            <p class="text-grey mb-3">Cari Detayları</p>
                            <div class="flex justify-between">
                                <span class="font-semibold">Cari bakiye</span>
                                <span class="font-medium text-danger cursor-pointer">149999</span>
                            </div>

                            <vs-divider />

                            <p class="font-semibold mb-3">İşlem Detayları</p>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">Toplam $</span>
                                <span>{{aratoplam}}</span>
                            </div>
                             <div class="flex justify-between mb-2">
                                <span class="text-grey">Toplam ₺</span>
                                <span>{{aratoplamtl}}</span>
                            </div>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">Ödeme Tipi</span>
                                
                               <vs-button color="success" type="gradient" icon-pack="feather" icon="icon-user-plus"></vs-button>
                               <vs-button color="primary" type="gradient" icon-pack="feather" icon="icon-credit-card"></vs-button>
                               <vs-button color="danger" type="gradient" icon-pack="feather" icon="icon-archive"></vs-button>
                                
                            </div>
                            
                            <vs-divider />
                            <div class="flex justify-between mb-2">
                            <vs-button class="w-full" @click="$refs.checkoutWizard.nextTab()">Satış</vs-button>
                            <vs-button class="w-full" @click="$refs.checkoutWizard.nextTab()">Yazdır</vs-button>
                            </div>
                        </vx-card>
                    </div>


    </div>
  


     

          
           
    </div>
</template>



<script>
export default {
  data () {
    return {
 list: [],
 aratoplam:0,
 aratoplamtl:0
    }
  },methods: {
    stokListeEkle(data) {
      let d= this.list.filter(function(elem){
    if(elem.stokkodu == data.stokKodu) return elem.stokkodu;
        });
        if (d.length>0) {

          const index = this.indexbul(this.list, item => item.stokkodu === data.stokKodu)
          let yeniadet=Number(this.list[index].adet)+1
          this.list[index].adet=yeniadet
          this.list[index].tarih=new Date()

        } else {
          this.list.push({stokkodu:data.stokKodu,stokadi:data.text,fiyat:data.satisFiyati,adet:'1',stokadet:data.bakiye,sonalis:data.sonAlis,tarih:new Date()})
        } 
         this.list.sort((a,b)=> b.tarih-a.tarih) 
       // const self = this;

        this.$nextTick(() => {
        this.focusInput();
      });

     

          
        //console.log(this.list)    
    },indexbul(array, conditionFn) {
        const item = array.find(conditionFn)
        return array.indexOf(item)
      },listesil(gelenkod) {
         const index = this.indexbul(this.list, item => item.stokkodu === gelenkod)
        this.list.splice(index,1)
      },focusInput() {
        let input = this.$refs.adetinput[0];
         console.log(input)
      }

  },
  watch: {
    list: {
      handler: function () {
       
        this.aratoplam=this.list.reduce((acc, item) => Number(acc) + (Number(item.adet)*Number(item.fiyat)), 0)
        
      },
      deep: true
    }
  }
}

</script>
<style lang="scss" scoped>
.satirinput {
  width:50%;
  autocomplete:off
}
.mb-base { margin-bottom: 0.75rem!important;}
.list-view-item {
    .item-name, .item-description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .item-name {
        -webkit-line-clamp: 2;
    }

    .item-description {
        -webkit-line-clamp: 5;
    }

    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
</style>
